export const METAMASK_GAS_LIMIT_ASSOCIATE=800_000;
export const METAMASK_GAS_LIMIT_TRANSFER_FT=50_000;
export const METAMASK_GAS_LIMIT_TRANSFER_NFT=100_000;
